/**
 * Humanize a machine category slug for DISPLAY ONLY. The raw value (e.g. `t_shirt`) is still what we
 * send to the server (facet ids, refine queries); this only changes how it reads on screen.
 *
 * Rule (per product owner): underscores become hyphens and each word is title-cased, so `t_shirt`
 * renders as "T-Shirt". Delimiters (hyphen/space) are preserved verbatim, and already-readable
 * labels ("Knitwear") pass through capitalized and otherwise unchanged.
 */
export function formatCategoryLabel(raw: string): string {
  return (
    raw
      .replace(/_/g, '-')
      // Split on hyphens/spaces but KEEP them (capture group) so we can rejoin exactly as-is.
      .split(/([\s-]+)/)
      .map((part) =>
        /^[a-z]/i.test(part) ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part,
      )
      .join('')
  )
}
